import { IReduxStore } from "Redux/Store/IReduxStore";

export const isApplicationLoading = (store: IReduxStore) => !store.global.isInitialized;
